<template>
  <div class="bg-white">
    <!-- <Head></Head> -->
    <section class="w">
      <div class="part">
      <h1>{{ $t('Home.terms.TermsConditions.TermsConditions') }}</h1>
    <p>{{ $t('Home.terms.TermsConditions.Tips1') }}</p>
    </div>
    <div class="part">
      <h2>{{ $t('Home.terms.TermsConditions.Tips2') }}</h2>
      <p>{{ $t('Home.terms.TermsConditions.Tips3') }}</p>
    </div>
    <div class="part">
      <h2>{{ $t('Home.terms.TermsConditions.Tips4') }}</h2>
      <p>{{ $t('Home.terms.TermsConditions.Tips5') }}</p>
    </div>
    <div class="part">
      <h2>{{ $t('Home.terms.TermsConditions.Tips6') }}</h2>
      <p>{{ $t('Home.terms.TermsConditions.Tips7') }}</p>
      <p>{{ $t('Home.terms.TermsConditions.Tips8') }}</p>
      <p>{{ $t('Home.terms.TermsConditions.Tips9') }}</p>
      <p>{{ $t('Home.terms.TermsConditions.Tips10') }}</p>
    </div>
    <div class="part">
      <h2>{{ $t('Home.terms.TermsConditions.Tips11') }}</h2>
      <p>{{ $t('Home.terms.TermsConditions.Tips12') }}</p>
    </div>
    <img src="https://www.9-bill.com/?v=GWJb7cgfSvxYjui0UAtO"/>
    </section>
    <!-- <Footer></Footer> -->
  </div>
</template>

<script>
// import Head from '../components/Head.vue'
// import Footer from '../components/Footer.vue'
export default {
  metaInfo: {
    title: 'Terms & Conditions - KakaClo',
    meta: [
      {
        name: 'description',
        content: 'KakaClo is the industry-leading apparel supply chain platform that focuses on providing customers with in stock apparel custom production and dropshipping service.'
      }
    ]
  },
  name: 'termsConditions'
  // components: { Head, Footer }

}
</script>

<style lang="scss" scoped>
@import '../css/term.scss';
</style>
